import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link has been sent.");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title={t("forgot_password")} subtitle="Enter your email and we'll send a reset link."
      footer={<Link to="/login" className="text-orange-400 font-semibold">{t("sign_in")}</Link>}>
      {sent ? (
        <p className="text-emerald-400 text-sm" data-testid="forgot-sent-message">A reset link has been sent to your email if the account exists. Check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label>{t("email")}</Label><Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
          <Button type="submit" disabled={busy} data-testid="forgot-submit-button" className="w-full bg-orange-600 hover:bg-orange-500 btn-glow font-semibold py-6">{busy ? "..." : t("send")}</Button>
        </form>
      )}
    </AuthShell>
  );
}
